export default "__VITE_ASSET__2383bea8__"